<template>
  <div id="app">
    <Chatbot />
  <div class="peru" v-if="isChile"><a href="/peru">Soy de Perú</a></div>
  <div class="peru" v-if="!isChile"><a href="/chile">No soy de Perú</a></div>
  </div>
</template>

<script>
import Chatbot from './components/Chatbot.vue'

export default {
  name: 'App',
  components: {
    Chatbot
  },
  computed:{
    isChile: () => document.location.pathname.split('/')[1] === 'chile'
  }
}
</script>

<style lang="scss">
#app {
  font-family: Roboto,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.peru{
  display: flex;
  position: absolute;
  z-index: 2222;
  bottom: 5%;
  left: calc(50% - 88px/2);
  a {
  color: #fff;
  }
  margin: auto;
}
</style>
